/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Parts_OnlyInputs */

const en_val_parts_only = /** @type {(inputs: Val_Parts_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parts Only`)
};

const es_val_parts_only = /** @type {(inputs: Val_Parts_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo para piezas`)
};

const fr_val_parts_only = /** @type {(inputs: Val_Parts_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour pièces uniquement`)
};

const de_val_parts_only = /** @type {(inputs: Val_Parts_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Ersatzteile`)
};

const ja_val_parts_only = /** @type {(inputs: Val_Parts_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジャンク・部品取り用`)
};

const zh_val_parts_only = /** @type {(inputs: Val_Parts_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅作零件`)
};

const ar_val_parts_only = /** @type {(inputs: Val_Parts_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقطع الغيار فقط`)
};

const id_val_parts_only = /** @type {(inputs: Val_Parts_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya Suku Cadang`)
};

const it_val_parts_only = /** @type {(inputs: Val_Parts_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo per Parti di Ricambio`)
};

const ru_val_parts_only = /** @type {(inputs: Val_Parts_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На запчасти`)
};

const pt_val_parts_only = /** @type {(inputs: Val_Parts_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somente para Peças`)
};

const ko_val_parts_only = /** @type {(inputs: Val_Parts_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고장(부품용)`)
};

/**
* | output |
* | --- |
* | "Parts Only" |
*
* @param {Val_Parts_OnlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_parts_only = /** @type {((inputs?: Val_Parts_OnlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Parts_OnlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_parts_only(inputs)
	if (locale === "es") return es_val_parts_only(inputs)
	if (locale === "fr") return fr_val_parts_only(inputs)
	if (locale === "de") return de_val_parts_only(inputs)
	if (locale === "ja") return ja_val_parts_only(inputs)
	if (locale === "zh") return zh_val_parts_only(inputs)
	if (locale === "ar") return ar_val_parts_only(inputs)
	if (locale === "id") return id_val_parts_only(inputs)
	if (locale === "it") return it_val_parts_only(inputs)
	if (locale === "ru") return ru_val_parts_only(inputs)
	if (locale === "pt") return pt_val_parts_only(inputs)
	return ko_val_parts_only(inputs)
});